import { render, staticRenderFns } from "./manuscript-toolbar.vue?vue&type=template&id=e32f306a&scoped=true&"
import script from "./manuscript-toolbar.vue?vue&type=script&lang=ts&"
export * from "./manuscript-toolbar.vue?vue&type=script&lang=ts&"
import style0 from "./manuscript-toolbar.vue?vue&type=style&index=0&id=e32f306a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32f306a",
  null
  
)

export default component.exports